import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { DetailProperty } from '../objects/DetailObject';
import { CountdownComponent } from 'ngx-countdown';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { HeaderService } from '../services/header.service';
import { DeviceDetectorService } from 'ngx-device-detector';
var CountdownTimerComponent = /** @class */ (function () {
    function CountdownTimerComponent(headerService, deviceService) {
        this.headerService = headerService;
        this.deviceService = deviceService;
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        this.warning = false;
        this.isMobile = false;
        this.countdownEnd = new EventEmitter();
        this.isMobile = deviceService.isMobile();
    }
    CountdownTimerComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(CountdownTimerComponent.prototype, "setProperty", {
        set: function (prop) {
            this.title = prop.PropertyDisplay.split('|')[0];
            this.subtitle = prop.PropertyDisplay.split('|')[1];
            if (prop.ParentPropertyValue) {
                this.getDurationCountdown(prop);
            }
        },
        enumerable: true,
        configurable: true
    });
    CountdownTimerComponent.prototype.getDurationCountdown = function (prop) {
        var _this = this;
        this.endDate = new Date(prop.ParentPropertyValue);
        var time = this.checkDuration();
        if (time > 0) {
            if (this.sub)
                this.sub.unsubscribe();
            if (this.sub1)
                this.sub1.unsubscribe();
            var timer = Observable.timer(0, 1000);
            var timer2 = Observable.timer(0, 5000);
            this.sub = timer.subscribe(function (t) { return _this.convertTime(time - (1 * t)); });
            this.sub1 = timer2.subscribe(function (t) { return _this.syncDuration(); });
        }
        else {
            this.days = 0;
            this.hours = 0;
            this.minutes = 0;
            this.seconds = 0;
        }
    };
    CountdownTimerComponent.prototype.checkDuration = function () {
        var momentCurrentDate = moment(new Date());
        if (this.headerService.getCurrentUserDateTime()) {
            momentCurrentDate = this.headerService.getCurrentUserDateTime();
        }
        var momentEndDate = moment(this.endDate ? this.endDate : new Date());
        var duration = moment.duration(momentEndDate.diff(momentCurrentDate));
        var time = Math.round(duration.asSeconds());
        return time;
    };
    CountdownTimerComponent.prototype.syncDuration = function () {
        var _this = this;
        var time = this.checkDuration();
        if (this.sub)
            this.sub.unsubscribe();
        var timer = Observable.timer(0, 1000);
        this.sub = timer.subscribe(function (t) { return _this.convertTime(time - (1 * t)); });
    };
    CountdownTimerComponent.prototype.handleEvent = function (event) {
        console.log(event);
    };
    CountdownTimerComponent.prototype.convertTime = function (seconds) {
        if (seconds < 1398) {
            this.warning = true;
        }
        if (seconds == 0) {
            if (this.sub)
                this.sub.unsubscribe();
            if (this.sub1)
                this.sub.unsubscribe();
            this.countdownEnd.emit(true);
        }
        else if (seconds < 0) {
            seconds = 0;
        }
        var days = Math.floor(seconds / (3600 * 24));
        seconds -= days * 3600 * 24;
        var hrs = Math.floor(seconds / 3600);
        seconds -= hrs * 3600;
        var mnts = Math.floor(seconds / 60);
        seconds -= mnts * 60;
        this.days = days;
        this.hours = hrs;
        this.minutes = mnts;
        this.seconds = seconds;
    };
    CountdownTimerComponent.prototype.ngOnDestroy = function () {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        if (this.sub1) {
            this.sub1.unsubscribe();
        }
    };
    return CountdownTimerComponent;
}());
export { CountdownTimerComponent };
